import { requireRouteAudience } from '@services/router/routeAccess';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/report-hub')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: 'Reports',
        }
    }
})

function RouteComponent() {
    const mainElement = document.getElementById('app-shell-main');
    const mainHeight = mainElement ? mainElement.clientHeight : 950;

    return (
        <div style={{ height: mainHeight - 95 }}>
            <iframe
                src="https://reports.godalming.ac.uk"
                className="w-full h-full border-0"
                title="Reports"
            />
        </div>
    )
}
